import { Injectable } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';
import { AchievementAlert } from '@app/models';

@Injectable({ providedIn: 'root' })
export class AchievementAlertService {
    private API_URL = '/api/achievement-alerts/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    private currentBeingViewed;

    public alertTypes: any[] = [
        {label: 'Invite', value: 'invite'},
        {label: 'Email', value: 'email'}
    ];

    public sourceTypes: any[] = [
        {label: 'Normal', value: 'normal'},
        {label: 'Customized', value: 'template'}
    ];


    constructor(
        private formBuilder: UntypedFormBuilder,
        private httpClient: HttpClient
    ) { }


    setCurrentBeingViewed(_achievementAlert: AchievementAlert): void {
        this.currentBeingViewed = _achievementAlert;
    }


    getCurrentBeingViewed(): AchievementAlert {
        return this.currentBeingViewed;
    }


    get(_id: string): Observable<AchievementAlert> {
        return this.httpClient.get<AchievementAlert>(this.API_URL + _id);
    }


    getAll(): Observable<AchievementAlert[]> {
        return this.httpClient.get<AchievementAlert[]>(this.API_URL);
    }


    create(_achievementAlert): Observable<AchievementAlert> {
        return this.httpClient.post<AchievementAlert>(this.API_URL, JSON.stringify(_achievementAlert), this.headerOptions);
    }


    update(_achievementAlert: AchievementAlert): Observable<AchievementAlert> {
        return this.httpClient.put<AchievementAlert>(`${this.API_URL}/${_achievementAlert._id}`, JSON.stringify(_achievementAlert), this.headerOptions);
    }


    delete(id: string): Observable<AchievementAlert> {
        return this.httpClient.delete<AchievementAlert>(this.API_URL + id);
    }


    deleteByAchievement(achievementId: string): Observable<AchievementAlert> {
        return this.httpClient.delete<AchievementAlert>(this.API_URL + 'by-achievement/' + achievementId);
    }


    search(searchTerms): Observable<AchievementAlert[]> {
        return this.httpClient.post<AchievementAlert[]>(this.API_URL + 'search', JSON.stringify(searchTerms), this.headerOptions);
    }


    selectAllSearch(searchTerms: AchievementAlert): Observable<AchievementAlert[]> {
        searchTerms['selectAll'] = true;
        return this.httpClient.post<AchievementAlert[]>(this.API_URL + 'search', JSON.stringify(searchTerms), this.headerOptions);
    }


    achievementAlertFormGroup(formData: AchievementAlert) {
        return this.formBuilder.group({
            achievement: [formData.achievement, Validators.required],
            name: [formData.name],
            alertType: [formData.alertType, Validators.required],
            sourceType: [formData.sourceType, Validators.required],
            subject: [formData.subject],
            message: [formData.message],
            campaignTemplate: [formData.campaignTemplate],
            variable_module: [formData.variable_module],
            variable_field: [formData.variable_field],
            variable: [formData.variable]
        });
    }
}